import { type FC } from "react";
import {
  DetailCard,
  DetailCardRow,
  DetailCardsGrid,
} from "../../../components/detail-cards";
import { formatMinorUnits, type PriceCatalogueProfile } from "../types";

interface FixedPriceProfilesCardsProps {
  profiles: PriceCatalogueProfile[];
}

const FixedPriceProfilesCards: FC<FixedPriceProfilesCardsProps> = ({
  profiles,
}) => {
  if (!profiles.length) return null;

  return (
    <DetailCardsGrid $columns={3}>
      {profiles.map((profile) => (
        <DetailCard key={profile.id} title={profile.label || profile.key}>
          <DetailCardRow label="Key" value={profile.key} />
          <DetailCardRow label="Option" value={profile.subscriptionOption} />
          <DetailCardRow
            label="Level"
            value={profile.subscriptionLevel || "—"}
          />
          <DetailCardRow
            label="Currency"
            value={String(profile.billingCurrency || "").toUpperCase()}
          />
          <DetailCardRow label="Interval" value={profile.interval || "—"} />
          <DetailCardRow
            label="Price"
            value={formatMinorUnits(
              profile.fixedPriceMinorUnits,
              profile.billingCurrency
            )}
          />
        </DetailCard>
      ))}
    </DetailCardsGrid>
  );
};

export default FixedPriceProfilesCards;
